import { styled, Box } from '../../../../base';

export const StyledMetricsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
}));

export const StyledMetricCard = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '1 1 auto',
}));

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
    borderRadius: '50%',
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
    boxShadow: theme.shadows[18],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    width: 45,
}));

export const StyledVerticalDivider = styled(Box)(({ theme }) => ({
    width: 1,
    height: 35,
    backgroundColor: theme.palette.divider,
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));
